import React, { useEffect, useRef, useState } from 'react';
import './FadeInOnView.css';

function FadeInOnView({ children, threshold = 0.1, rootMargin = '0px', className = '' }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Disconnect observer after element becomes visible to improve performance
          observer.disconnect();
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [threshold, rootMargin]);

  return (
    <div
      ref={ref}
      className={`fade-in-on-view ${isVisible ? 'fade-in-on-view--visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
}

export default FadeInOnView;